import { render } from "./identityCard.vue?vue&type=template&id=f9fe17bc&scoped=true"
import script from "./identityCard.vue?vue&type=script&lang=js"
export * from "./identityCard.vue?vue&type=script&lang=js"

import "./identityCard.vue?vue&type=style&index=0&id=f9fe17bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fe17bc"]])

export default __exports__